import React from 'react';
import Slider from 'react-slick';
import Angular2Logo from "../../../assets/img/logos/angular2-logo.png"
import Ionic2Logo from "../../../assets/img/logos/ionic2-logo.png"
import NodeLogo from "../../../assets/img/logos/nodejs-logo.png"
import MongoLogo from "../../../assets/img/logos/mongodb-logo.png"
import TypeScriptLogo from "../../../assets/img/logos/typescript-logo.png"
import VueLogo from "../../../assets/img/logos/vuejs-logo.png"
import HerokuLogo from "../../../assets/img/logos/heroku-logo.png"
import NPMLogo from "../../../assets/img/logos/npm-logo.png"
import SassLogo from "../../../assets/img/logos/sass-logo.png"
import GithubLogo from "../../../assets/img/logos/github-logo.png"
import RedisLogo from "../../../assets/img/logos/redis-logo.png"
import ReactLogo from "../../../assets/img/logos/react-logo.png"
import GruntLogo from "../../../assets/img/logos/grunt-logo.png"
import GulpLogo from "../../../assets/img/logos/gulp-logo.png"
import BowerLogo from "../../../assets/img/logos/bower-logo.png"
import AngularLogo from "../../../assets/img/logos/angular-logo.png"
//TO DO: add webpack, gatsny, graphql
const SkillsSlider = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        slidesToScroll: 1,
        slidesToShow: 5,
        responsive: [{ breakpoint: 600, settings: { slidesToShow: 1, dots: false } }, { breakpoint: 800, settings: { slidesToShow: 3 } }, { breakpoint: 1000, settings: { slidesToShow: 4 } }, { breakpoint: 1200, settings: { slidesToShow: 5 } }],
        nextArrow: <SampleNextArrow className="arrow next-arrow" />,
        prevArrow: <SamplePrevArrow className="arrow prev-arrow" />
    };


    const images = [
        Angular2Logo, Ionic2Logo, NodeLogo, MongoLogo, ReactLogo, TypeScriptLogo, VueLogo, HerokuLogo, NPMLogo, SassLogo, GithubLogo, RedisLogo, GruntLogo, GulpLogo, BowerLogo, AngularLogo
    ];
    const slides = images.map((image) =>
        <div className="slide" key={image.toString() + Math.random().toString()}>
            <img src={image} />
        </div>
    );
    return (
        <div className="slick-wrapper">
            <Slider {...settings}>
                {slides}
            </Slider>
        </div>
    )
};

function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
        <div
            className={className}
            style={{ ...style, display: 'block' }}
            onClick={onClick}
        ><i aria-hidden="true" className="fa fa-angle-right"></i></div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
        <div
            className={className}
            style={{ ...style, display: 'block' }}
            onClick={onClick}
        ><i aria-hidden="true" className="fa fa-angle-left"></i></div>
    );
}

export default SkillsSlider;


// WEBPACK FOOTER //
// ./src/components/home/Skills/slider.js